import React from "react";
import Layout from "../Layouts/defaultLayout";
import Map from "../components/map";
import SideBar from "../components/sideBar";
import axios from "axios";
import MetricCard from "../components/metricCards";
import {
  GetMaxRevenue,
  MaxRevAreas,
  GetCount,
  MoreCampaign,
  RatioOff,
} from "../helpers/mapHelper";
import {
  SetData,
  getData,
  getMaxUsers,
  getMaxFemale,
  getMaxMale,
} from "../helpers/dataHelper";
import DataPopUp from "../components/dataPopup";
import Footer from "../components/footer";
import { FlyToInterpolator } from "react-map-gl";
import { easeCubic } from "d3-ease";
import Header from "../components/header";
import Loading from "../assets/loading.gif";
import {areasData, userData} from "../helpers/staticData"
// eslint-disable-next-line import/no-webpack-loader-syntax

class Index extends React.Component {
  constructor() {
    super();
    this.state = {
      viewport: {
        latitude: 12.9716,
        longitude: 77.5946,
        width: "100vw",
        height: "100vh",
        zoom: 9.8,
      },
      loading: false,
      areas: [],
      users: [],
      maxRev: 199,
      minRev: 100,
      metric: "objectid",
      metricLayers: [
        {
          id: 1,
          title: "Revenue",
          description:
            "Areas with good revenue (users who have opted in/paid for Pro features)",
          selected: false,
        },
        {
          id: 2,
          title: "Campaign requirements",
          description:
            "Areas which requires more user acquisition campaigns (Less number of users compared to other areas)",
          selected: false,
        },
        {
          id: 3,
          title: "User gender Ratio",
          description: "Areas where ratio of males to females are off",
          selected: false,
        },
        {
          id: 4,
          title: "Max Users",
          description: "Areas with more Number of users",
          selected: true,
        },
        {
          id: 5,
          title: "Max Females",
          description: "Areas with more Number of female Users",
          selected: false,
        },
        {
          id: 6,
          title: "Max Male",
          description: "Areas with more Number of male Users",
          selected: false,
        },
      ],
    };
    this.updateMetrics = this.updateMetrics.bind(this);
    this.getMetrics = this.getMetrics.bind(this);
    this.setMetricsSelected = this.setMetricsSelected.bind(this);
    this.getArea = this.getArea.bind(this);
    this.setViewport = this.setViewport.bind(this);
  }
  async componentDidMount() {
    this.setState({ loading: true });
    const Area = "https://kyupid-api.vercel.app/api/areas";
    const Users = "https://kyupid-api.vercel.app/api/users";
    let users = {
      data: userData,
    };
    let areas = {
      data: areasData,
    };
    // console.log(areas);
    let totalPro = 0;
    let totalFemales = 0;
    let totalMale = 0;
    let modiFeatures = areas.data.features.map((info, index) => {
      let userCount = users.data.users.filter(
        (user) => user.objectid === info.properties.objectid
      );
      let revenue = GetMaxRevenue(info, users.data.users);
      let { MaleCount, FemaleCount, ProCount } = GetCount(
        info,
        users.data.users
      );
      totalMale += MaleCount;
      totalFemales += FemaleCount;
      totalPro += ProCount;
      let area = { ...info };
      area.properties = {
        ...area.properties,
        userCount: userCount.length,
        maleCount: MaleCount,
        femaleCount: FemaleCount,
        proCount: ProCount,
        revenue,
      };
      return area;
    });
    areas.data["features"] = modiFeatures;
    areas.data["totalFemales"] = totalFemales;
    areas.data["totalMale"] = totalMale;
    areas.data["totalProcount"] = totalPro;

    // console.log(areas.data.features);
    if (areas.data.features.length > 0) {
      await SetData(areas.data.features);
      areas.data["features"] = await getMaxUsers();
    }
    this.setState({
      areas: areas.data,
      users: users.data.users,
      loading: false,
    });
  }

  async updateMetrics(id) {
    if (this.state.areas.features.length > 0) {
      // console.log(id);

      if (id == 1) {
        let ModifiedFeatures = await MaxRevAreas(this.state.areas.features, 5);
        this.setState({
          areas: { ...this.state.areas, features: ModifiedFeatures },
          metric: "proCount",
        });
      } else if (id === 2) {
        let ModifiedFeatures = await MoreCampaign(this.state.areas.features, 5);
        this.setState({
          areas: { ...this.state.areas, features: ModifiedFeatures },
          metric: "userCount",
        });
      } else if (id === 3) {
        let ModifiedFeatures = await RatioOff(this.state.areas.features, 5);
        this.setState({
          areas: { ...this.state.areas, features: ModifiedFeatures },
          metric: "userCount",
        });
      } else if (id === 4) {
        let ModifiedFeatures = await getMaxUsers();
        this.setState({
          areas: { ...this.state.areas, features: ModifiedFeatures },
          metric: "userCount",
        });
      } else if (id === 5) {
        let ModifiedFeatures = await getMaxFemale();
        this.setState({
          areas: { ...this.state.areas, features: ModifiedFeatures },
          metric: "femaleCount",
        });
      } else if (id === 6) {
        let ModifiedFeatures = await getMaxMale();
        this.setState({
          areas: { ...this.state.areas, features: ModifiedFeatures },
          metric: "maleCount",
        });
      }
    }
  }

  setMetricsSelected(id) {
    let metrics = this.state.metricLayers.map((data) => {
      let temp = { ...data, selected: false };
      if (data.id === id) {
        temp.selected = true;
      }
      return temp;
    });
    this.setState({ metricLayers: metrics });
  }

  getArea(id, ln, lt) {
    let ModifiedFeatures = this.state.areas.features.filter(
      (info) => info.properties.objectid === id
    );
    this.setState({
      areas: { ...this.state.areas, features: ModifiedFeatures },
      viewport: {
        latitude: lt,
        longitude: ln,
        width: "100vw",
        height: "100vh",
        zoom: 12,
        transitionDuration: 2000,
        transitionInterpolator: new FlyToInterpolator(),
        transitionEasing: easeCubic,
      },
    });
  }

  getMetrics() {
    var Layers = this.state.metricLayers.map((info, index) => {
      return (
        <MetricCard
          key={index}
          title={info.title}
          description={info.description}
          selected={info.selected}
          onClick={() => {
            this.updateMetrics(info.id);
            this.setMetricsSelected(info.id);
          }}
        />
      );
    });
    return Layers;
  }
  setViewport(e) {
    this.setState({ viewport: e });
  }

  render() {
    return (
      <Layout>
        {this.state.loading ? (
          <div className="loading">
            <img src={Loading} alt="loading..." />
          </div>
        ) : (
          <>
            <SideBar Metrics={this.getMetrics()} />
            <div className="layout-cont">
              <Map
                areaGeaJson={this.state.areas}
                maxRev={this.state.maxRev}
                minRev={this.state.minRev}
                metric={this.state.metric}
                getArea={this.getArea}
                viewport={this.state.viewport}
                setViewport={this.setViewport}
              />
              <DataPopUp
                getArea={this.getArea}
                totalPro={this.state.areas.totalPro}
                totalMale={this.state.areas.totalMale}
                totalFemales={this.state.areas.totalFemales}
                areas={this.state.areas.features}
                area={{
                  title: "12122",
                  description: "Total Users",
                  proCount: this.state.areas.totalProcount,
                  male: this.state.areas.totalMale,
                  female: this.state.areas.totalFemales,
                }}
              />
              <Header title="Bangalore" />

              <Footer
                onCenter={() => {
                  this.setState({
                    viewport: {
                      latitude: 12.9716,
                      longitude: 77.5946,
                      width: "100vw",
                      height: "100vh",
                      zoom: 9.8,
                      transitionDuration: 2000,
                      transitionInterpolator: new FlyToInterpolator(),
                      transitionEasing: easeCubic,
                    },
                  });
                }}
                onReset={async () => {
                  let features = await getData();
                  let metrics = this.state.metricLayers.map((data) => {
                    let temp = { ...data, selected: false };
                    return temp;
                  });
                  this.setState({
                    metricLayers: metrics,
                    areas: { ...this.state.areas, features: features },
                    metric: "userCount",
                    viewport: {
                      latitude: 12.9716,
                      longitude: 77.5946,
                      width: "100vw",
                      height: "100vh",
                      zoom: 9.8,
                      transitionDuration: 2000,
                      transitionInterpolator: new FlyToInterpolator(),
                      transitionEasing: easeCubic,
                    },
                  });
                }}
              />
            </div>
          </>
        )}
      </Layout>
    );
  }
}
export default Index;
